import styled from 'styled-components';
import { Descriptions, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const GreyText = styled(Typography.Text)`
  color: 'var(--neutral-7)';
`;

export const GreyInfoIcon = styled(InfoCircleOutlined)`
  color: 'var(--neutral-7)';
`;

export const WhiteDescriptions = styled(Descriptions)`
  border-width: 1px;
  border-style: solid solid none solid;
  border-color: #d9d9d9;
  background-color: white;
`;
